export const environment = {
  env: 'TEST',
  urlAddress: 'https://cykliskkalenderapi-test.krynn.dk',
};
